import React from 'react';
import ReactDOM from 'react-dom';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';

const popup = ({ title, content, onOk, onCancel }) =>
  new Promise((resolve, reject) => {
    const container = document.createElement(`popup-${new Date().getDate()}`);
    function destroyNode() {
      setTimeout(() => {
        document.body.removeChild(container);
        ReactDOM.unmountComponentAtNode(container);
      }, 100);
    }

    function handleOk() {
      destroyNode();
      resolve('ok');
      if (onOk) {
        onOk();
      }
    }
    function handleCancel() {
      destroyNode();
      resolve(null);
      if (onCancel) {
        onCancel();
      }
    }

    ReactDOM.render(
      <React.StrictMode>
        <Dialog open onClose={handleCancel} onBackdropClick={handleCancel}>
          <DialogTitle> {title}</DialogTitle>
          <DialogContent>{content}</DialogContent>
          <DialogActions>
            <Button onClick={handleCancel} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.StrictMode>,
      document.body.appendChild(container),
    );
  });

export default popup;
